import React, { useState, useEffect } from 'react';
import styles from './notes.module.css';
import person_icon from '../../../images/icons/AuditTrailIcons/person_icon.svg';
import edit_icon from '../../../images/icons/AuditTrailIcons/edit_icon.svg';
import delete_icon from '../../../images/icons/AuditTrailIcons/delete_icon.svg';

import CommonBtn from '../../../containers/LeadProfile/CommonBtn/CommonBtn';

const { more_option, textareaStyle, align_btns } = styles;

function NotesRow({
  isCreateMode,
  onClickAction,
  data,
  setNotesData,
  onDelete,
  updateNote,
  addNewNotes,
  index
}) {
  const [showEditMode, setShowEditMode] = useState(false);
  const [showEditDetele, setShowEditDelete] = useState(false);

  const [text, setText] = useState(data?.text || '');

  return (
    <div className={`mb-6`}>
      {!showEditMode && !isCreateMode && (
        <div className="canEditMode" onClick={() => setShowEditDelete(false)}>
          <div className="flex justify-between">
            <div className="flex text-white">
              <img
                src={person_icon}
                alt="icon"
                className="pr-2 relative"
                style={{
                  top: '6px'
                }}
              />
              <p className="pr-6 pt-2 text-sm font-roboto font-light">
                {data?.text}
              </p>
            </div>

            <div className="relative">
              <div
                className="text-white text-2xl font-medium relative h-0 cursor-pointer"
                onClick={e => {
                  e.stopPropagation();
                  setShowEditDelete(!showEditDetele);
                }}
              >
                ...
              </div>

              {showEditDetele && (
                <div
                  className={`flex flex-col shadow rounded bg-white text-white text-xs mt-1 ${more_option}`}
                >
                  <div
                    className="cursor-pointer pb-1 hover:font-medium"
                    onClick={() => {
                      setShowEditMode(true);
                    }}
                  >
                    <img src={edit_icon} alt="" className="inline-block pr-3" />
                    <span>Edit</span>
                  </div>
                  <div className="cursor-pointer hover:font-medium">
                    <img
                      src={delete_icon}
                      alt=""
                      className="inline-block pr-3"
                    />
                    <span
                      onClick={() => {
                        onDelete(index);
                      }}
                    >
                      Delete
                    </span>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="flex pt-4 text-grey-2221 text-xs">
            <p className="pr-5">{data?.name}</p>
            <p>{data?.date} </p>
          </div>
        </div>
      )}
      {(showEditMode || isCreateMode) && (
        <div className="topTextArea">
          <div className="flex items-baseline">
            <img
              src={person_icon}
              alt="icon"
              className="pr-2 relative"
              style={{
                top: '6px'
              }}
            />
            <textarea
              className={`${textareaStyle} w-full py-2 px-3 rounded-md text-white`}
              value={text}
              placeholder="Add Notes Here ..."
              onChange={e => {
                setText(e.target.value);
                // setShowBtn(true);
                //setNotesValue(e.target.value);
              }}
              rows={5}
            />
          </div>
          <div className={`flex justify-end ${align_btns}`}>
            <CommonBtn
              value="Cancel"
              classNameStyle="hover:font-medium"
              stylesBtn={{
                backgroundColor: '#FD4F60',
                border: 'none',
                color: 'white',
                padding: '5px 15px'
              }}
              onClick={() => {
                if (isCreateMode) {
                  setText('');
                }
                setShowEditMode(false);
              }}
            />
            <CommonBtn
              value={isCreateMode ? 'Send' : 'Submit'}
              onClick={() => {
                setShowEditMode(false);
                if (!isCreateMode) {
                  updateNote(text, index);
                }
                if (isCreateMode) {
                  if (text) {
                    addNewNotes(text);
                  }

                  setText('');
                }
                if (onClickAction) {
                  onClickAction({
                    info: {
                      text,
                      data
                    }
                  });
                }
              }}
              classNameStyle="hover:font-medium"
              stylesBtn={{
                backgroundColor: '#1CB1BD',
                border: 'none',
                color: 'white',
                padding: '5px 15px'
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default NotesRow;
